import { IconButton, Tooltip } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid/models/colDef/gridColDef';
import { Pencil, Wallpaper } from 'lucide-react';
import React from 'react';
import { FlagDTO, StopDTO } from '@/model';
import { AssignedLayoutStopModalConfig } from '@/page';
import { TranslationFunction } from '@/type';

// Keeps the selected announcement and the item filter restored after
// navigating away to the item editor and back — the state lives in the URL
// itself instead of component state, so it survives the page remount that a
// route change causes.
export const validateAnnouncementSearch = (search: Record<string, unknown>) => {
  const selectedAnnouncementId = Number(search.selectedAnnouncementId);
  // Absent by default, so the item list starts filtered to in-progress items.
  const showAllItems = search.showAllItems === true;

  return {
    ...(!Number.isNaN(selectedAnnouncementId) && { selectedAnnouncementId }),
    ...(showAllItems && { showAllItems }),
  };
};

export const linkedStops = (fetchedStops: StopDTO[]) =>
  fetchedStops?.map((stop) => ({
    id: String(stop.id),
    name: stop.name,
  }));

export const linkedFlags = (fetchedFlags: FlagDTO[]) =>
  fetchedFlags?.map((flag) => ({
    id: String(flag.id),
    name: `⚑ ${flag.label}`,
    items: flag.stops?.map((stop) => String(stop.id)),
  }));

export const announcementTableColumns = (
  openEditAnnouncementModal: (id: number) => void,
  deleteAnnouncement: (id: number) => void,
  setAssignedLayoutStopModalConfig: (
    assignedLayoutStopModalConfig: AssignedLayoutStopModalConfig,
  ) => void,
  hasManagerGroup: boolean,
  hasRichTextWritePermission: boolean,
  t: TranslationFunction,
): GridColDef[] => [
  {
    field: 'name',
    headerName: t('announcement.goup-name'),
    headerClassName: 'displays-table-header',
    cellClassName: 'displays-table-cell',
    headerAlign: 'center',
    align: 'left',
    editable: false,
    flex: 1,
    renderCell: (params) => <span className='table-cell-trucate'>{params.row.name}</span>,
  },
  {
    field: 'description',
    headerName: t('announcements.table.header.description'),
    headerClassName: 'displays-table-header',
    cellClassName: 'displays-table-cell',
    headerAlign: 'center',
    align: 'center',
    editable: false,
    flex: 2,
    renderCell: (params) => (
      <span className='table-cell-trucate'>{params.row.description}</span>
    ),
  },
  {
    field: 'groupNames',
    headerName: t('common.groups'),
    headerClassName: 'displays-table-header',
    cellClassName: 'displays-table-cell',
    headerAlign: 'center',
    align: 'left',
    editable: false,
    flex: 1,
    valueGetter: (value: string[]) => (Array.isArray(value) ? value.join(', ') : ''),
  },
  {
    headerName: t('general.table.header.actions'),
    field: 'actions',
    filterable: false,
    sortable: false,
    headerAlign: 'center',
    align: 'center',
    flex: 2,
    renderCell: (params) => (
      <div className='last-cell'>
        <div className='action-part first-action-part'>
          {!hasManagerGroup && hasRichTextWritePermission && (
            <IconButton
              className='row-edit-button'
              onClick={() => openEditAnnouncementModal(params.row.id)}
            >
              <Tooltip
                className='edit-row-button'
                title={t('general.edit-row-data.button')}
              >
                <div>
                  <Pencil size={'20px'} />
                </div>
              </Tooltip>
            </IconButton>
          )}
          {/*{!hasManagerGroup && (*/}
          {/*  <IconButton onClick={() => deleteAnnouncement(params.row.id)}>*/}
          {/*    <Tooltip*/}
          {/*      className='edit-row-button'*/}
          {/*      title={t('general.delete-row-data.button')}*/}
          {/*    >*/}
          {/*      <div>*/}
          {/*        <Delete />*/}
          {/*      </div>*/}
          {/*    </Tooltip>*/}
          {/*  </IconButton>*/}
          {/*)}*/}
          <IconButton
            className='row-edit-button'
            onClick={() =>
              setAssignedLayoutStopModalConfig({
                isOpen: true,
                announcementId: params.row.id,
              })
            }
          >
            <Tooltip title={t('announcement.assigned-layouts-stops')}>
              <div>
                <Wallpaper size={'20px'} />
              </div>
            </Tooltip>
          </IconButton>
        </div>
      </div>
    ),
  },
];
